"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var NotSupport = function (_super) {
  __extends(NotSupport, _super);

  function NotSupport() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NotSupport.prototype.render = function () {
    var _a = this.props,
        iconName = _a.iconName,
        title = _a.title,
        desc = _a.desc;
    return React.createElement("div", {
      className: "HydroSDK-notSupport"
    }, React.createElement(Svg_1.default, {
      name: iconName,
      size: "80"
    }), React.createElement("div", {
      className: "HydroSDK-notSupportTitle"
    }, title), React.createElement("div", {
      className: "HydroSDK-notSupportDesc",
      dangerouslySetInnerHTML: {
        __html: desc
      }
    }));
  };

  return NotSupport;
}(React.PureComponent);

exports.default = NotSupport;